import React from 'react';
import PropTypes from 'prop-types';

import Messages from '../../../fragments/messages';
import ValidateDialog from '../../../../components/validate-dialog';


export default class DialogPrompt extends React.Component {

  static propTypes = {
    rawDataCollection: PropTypes.object.isRequired,
    showDialog: PropTypes.bool.isRequired,
    showSubmit: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
  };

  render() {
    const {rawDataCollection} = this.props;

    const messages = rawDataCollection.messages(
      'rawRxHistory', true, false, false);
    const noMessage = (messages.length === 0);

    return (
      <ValidateDialog {...this.props}>
        {noMessage?
        'Passed validation, no regimen history error.' :
        <Messages
         messages={messages}
         noIndent
         scrollable
        />
        }
      </ValidateDialog>
    );
  }

}



// WEBPACK FOOTER //
// ./src/views/wizard/rx-list/gtable/dialog-prompt.js